import React from "react";
import { Field } from "formik";
import { useTranslation } from 'react-i18next';
import TextField from "../../shared/forms/controls/TextField";
import FieldGroup from "../../shared/forms/layout/FieldGroup";

export default () => {
  const { t } = useTranslation();

  return (
    <>
      <FieldGroup>
        <Field
          component={TextField}
          label={t("Name")}
          name="name"
          variant="standard"
        />
      </FieldGroup>
    </>
  );
};
